import { trackAnalyticsEventLegacy } from '@autone/analytics';
import posthog from 'posthog-js';
import { useEffect } from 'react';

import {
  type API_CALL,
  type BUTTON_CLICK,
  type COPY_BUTTON_CLICKED,
  type DROPDOWN_SELECT,
  type EXPORT,
  type TEXT_CHANGE,
  type TOGGLE,
  VIEW_ACCESSED,
} from './eventTypes';

export * from './eventTypes';
export * from './pivotEvents';

/**
 * @deprecated This method is deprecated in favor of the {@link trackAnalyticsEvent} method.
 */
export const trackAnalyticsLegacyAction = (
  actionName: string,
  actionProperties?: Record<string, unknown> & {
    app?: 'replenishment' | 'rebalancing' | 'reorder' | 'events';
  },
) => {
  trackAnalyticsEventLegacy(actionName, actionProperties);
};

/**
 * @deprecated This method is deprecated in favor of the {@link trackAnalyticsEvent} method.
 */
export const trackAnalyticsLegacyEvent = (
  action:
    | typeof BUTTON_CLICK
    | typeof COPY_BUTTON_CLICKED
    | typeof TEXT_CHANGE
    | typeof EXPORT
    | typeof TOGGLE
    | typeof DROPDOWN_SELECT
    | typeof API_CALL,
  eventProperties?: Record<string, unknown> & {
    app:
      | 'replenishment'
      | 'rebalancing'
      | 'reorder'
      | 'events'
      | 'parameters'
      | 'hub'
      | 'assortment'
      | 'events';
    event: string;
    value?: string | number | null | boolean;
  },
) => {
  trackAnalyticsEventLegacy(action, eventProperties);
};

export type ViewMode = 'main' | 'sidepanel' | 'dialog';
export type TrackedAnaltyicsModuleViews =
  | 'overview'
  | 'new batch'
  | 'ongoing batches table'
  | 'upcoming batches table'
  | 'submitted batches table'
  | 'review batch'
  | 'locations table'
  | 'pivot main table'
  | 'pivot edit table'
  | 'receiving table'
  | 'sending table'
  | 'trips table'
  | 'products table'
  | 'product sizes table'
  | 'stock analysis table'
  | 'location sizes table'
  | 'departments table'
  | 'high level view'
  | 'product insights'
  | 'size edit'
  | 'parameters'
  | 'batch summary department table'
  | 'batch summary locations table'
  | 'archived batches table'
  | 'failed batches table'
  | 'explorer table';

export type AssortmentAnalyticsModuleViews = 'in-season view' | 'product view';

export type EventsAnalyticsModuleViews = 'calendar' | 'list';

type useTrackAnalyticsModuleViewsProps =
  | {
      app: 'replenishment' | 'rebalancing' | 'reorder';
      viewMode: ViewMode;
      view: TrackedAnaltyicsModuleViews | AssortmentAnalyticsModuleViews;
    }
  | {
      app: 'assortment';
      viewMode: 'main';
      view: AssortmentAnalyticsModuleViews;
    }
  | {
      app: 'events';
      viewMode: 'main';
      view: EventsAnalyticsModuleViews;
    };

export const useTrackModuleViews = ({
  app,
  view,
  viewMode,
}: useTrackAnalyticsModuleViewsProps) => {
  useEffect(() => {
    posthog.capture(VIEW_ACCESSED, {
      app,
      view,
      viewMode,
    });
  }, [app, view, viewMode]);
};

/**
 * @deprecated Use trackAnalyticsEvent instead
 */
export const Analytics = {
  track: (action: string, properties?: Record<string, unknown>) =>
    trackAnalyticsEventLegacy(action, {
      ...(properties || {}),
    }),
};
